import { render, staticRenderFns } from "./projectForm.vue?vue&type=template&id=16d2cb10&scoped=true&"
import script from "./projectForm.vue?vue&type=script&lang=js&"
export * from "./projectForm.vue?vue&type=script&lang=js&"
import style0 from "./projectForm.vue?vue&type=style&index=0&id=16d2cb10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d2cb10",
  null
  
)

export default component.exports